import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { MEASURES } from "../data/content";

export default function Measures() {
  return (
    <div data-testid="measures-page">
      <PageHeader
        overline="Our measures"
        title="Energy-saving home improvements"
        subtitle="Every measure is surveyed, funded and installed by our accredited network — with no upfront cost to you wherever you're eligible."
      />

      <section className="py-16 md:py-24 bg-brand-cream">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-16 md:space-y-24">
          {MEASURES.map((m, i) => (
            <Reveal key={m.slug}>
              <div className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}>
                <div className="rounded-3xl overflow-hidden" data-testid={`measure-detail-${m.slug}`}>
                  <img src={m.image} alt={m.name} className="w-full h-[380px] object-cover" />
                </div>
                <div>
                  <div className="w-12 h-12 rounded-xl bg-white border border-stone-200 flex items-center justify-center mb-5">
                    <m.icon className="w-6 h-6 text-brand-accent" />
                  </div>
                  <p className="font-outfit text-xs uppercase tracking-[0.2em] text-brand-accent font-bold mb-2">{m.tagline}</p>
                  <h2 className="font-outfit text-3xl sm:text-4xl font-semibold tracking-tight text-brand mb-4">{m.name}</h2>
                  <p className="font-figtree text-lg text-stone-600 mb-6">{m.desc}</p>
                  <ul className="grid sm:grid-cols-2 gap-3 mb-8">
                    {m.benefits.map((b) => (
                      <li key={b} className="flex items-center gap-2 font-figtree text-sm text-brand">
                        <Check className="w-4 h-4 text-brand-success shrink-0" /> {b}
                      </li>
                    ))}
                  </ul>
                  <Link to="/contact" className="inline-flex items-center gap-2 bg-brand-accent text-white hover:bg-brand-accenthover transition-colors rounded-full px-7 py-3.5 font-medium">
                    Check my eligibility <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
